/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AnalyticsResponse,
  HTTPValidationError,
  RecentCase,
  SettlementData,
  StatusEnum,
  ViolationTypeEnum,
} from '../models/index';
import {
    AnalyticsResponseFromJSON,
    AnalyticsResponseToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    RecentCaseFromJSON,
    RecentCaseToJSON,
    SettlementDataFromJSON,
    SettlementDataToJSON,
    StatusEnumFromJSON,
    StatusEnumToJSON,
    ViolationTypeEnumFromJSON,
    ViolationTypeEnumToJSON,
} from '../models/index';

export interface GetAnalyticsDataApiV1AnalyticsGetRequest {
    dateFrom?: Date | null;
    dateTo?: Date | null;
    recentCasesLimit?: number;
    search?: string | null;
    offices?: Array<string> | null;
    violationTypes?: Array<ViolationTypeEnum> | null;
    statusFilters?: Array<StatusEnum> | null;
    minAmount?: number | null;
    maxAmount?: number | null;
}

export interface GetAnalyticsDataApiV1AnalyticsGet0Request {
    dateFrom?: Date | null;
    dateTo?: Date | null;
    recentCasesLimit?: number;
    search?: string | null;
    offices?: Array<string> | null;
    violationTypes?: Array<ViolationTypeEnum> | null;
    statusFilters?: Array<StatusEnum> | null;
    minAmount?: number | null;
    maxAmount?: number | null;
}

export interface GetRecentCasesApiV1AnalyticsRecentCasesGetRequest {
    limit?: number;
}

export interface GetRecentCasesApiV1AnalyticsRecentCasesGet0Request {
    limit?: number;
}

export interface GetSettlementDataApiV1AnalyticsSettlementDataGetRequest {
    dateFrom?: Date | null;
    dateTo?: Date | null;
}

export interface GetSettlementDataApiV1AnalyticsSettlementDataGet0Request {
    dateFrom?: Date | null;
    dateTo?: Date | null;
}

/**
 * 
 */
export class AnalyticsApi extends runtime.BaseAPI {

    /**
     * Get comprehensive analytics data for the research dashboard. Returns both settlement data and recent cases in a single response.
     * Get Analytics Data
     */
    async getAnalyticsDataApiV1AnalyticsGetRaw(requestParameters: GetAnalyticsDataApiV1AnalyticsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AnalyticsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['dateFrom'] != null) {
            queryParameters['date_from'] = (requestParameters['dateFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['date_to'] = (requestParameters['dateTo'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['recentCasesLimit'] != null) {
            queryParameters['recent_cases_limit'] = requestParameters['recentCasesLimit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['offices'] != null) {
            queryParameters['offices'] = requestParameters['offices'];
        }

        if (requestParameters['violationTypes'] != null) {
            queryParameters['violation_types'] = requestParameters['violationTypes'];
        }

        if (requestParameters['statusFilters'] != null) {
            queryParameters['status_filters'] = requestParameters['statusFilters'];
        }

        if (requestParameters['minAmount'] != null) {
            queryParameters['min_amount'] = requestParameters['minAmount'];
        }

        if (requestParameters['maxAmount'] != null) {
            queryParameters['max_amount'] = requestParameters['maxAmount'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/analytics/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnalyticsResponseFromJSON(jsonValue));
    }

    /**
     * Get comprehensive analytics data for the research dashboard. Returns both settlement data and recent cases in a single response.
     * Get Analytics Data
     */
    async getAnalyticsDataApiV1AnalyticsGet(requestParameters: GetAnalyticsDataApiV1AnalyticsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AnalyticsResponse> {
        const response = await this.getAnalyticsDataApiV1AnalyticsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get comprehensive analytics data for the research dashboard. Returns both settlement data and recent cases in a single response.
     * Get Analytics Data
     */
    async getAnalyticsDataApiV1AnalyticsGet_1Raw(requestParameters: GetAnalyticsDataApiV1AnalyticsGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AnalyticsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['dateFrom'] != null) {
            queryParameters['date_from'] = (requestParameters['dateFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['date_to'] = (requestParameters['dateTo'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['recentCasesLimit'] != null) {
            queryParameters['recent_cases_limit'] = requestParameters['recentCasesLimit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['offices'] != null) {
            queryParameters['offices'] = requestParameters['offices'];
        }

        if (requestParameters['violationTypes'] != null) {
            queryParameters['violation_types'] = requestParameters['violationTypes'];
        }

        if (requestParameters['statusFilters'] != null) {
            queryParameters['status_filters'] = requestParameters['statusFilters'];
        }

        if (requestParameters['minAmount'] != null) {
            queryParameters['min_amount'] = requestParameters['minAmount'];
        }

        if (requestParameters['maxAmount'] != null) {
            queryParameters['max_amount'] = requestParameters['maxAmount'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/analytics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnalyticsResponseFromJSON(jsonValue));
    }

    /**
     * Get comprehensive analytics data for the research dashboard. Returns both settlement data and recent cases in a single response.
     * Get Analytics Data
     */
    async getAnalyticsDataApiV1AnalyticsGet_1(requestParameters: GetAnalyticsDataApiV1AnalyticsGet0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AnalyticsResponse> {
        const response = await this.getAnalyticsDataApiV1AnalyticsGet_1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get recent settlement cases for the research dashboard.
     * Get Recent Cases
     */
    async getRecentCasesApiV1AnalyticsRecentCasesGetRaw(requestParameters: GetRecentCasesApiV1AnalyticsRecentCasesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RecentCase>>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/analytics/recent-cases/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RecentCaseFromJSON));
    }

    /**
     * Get recent settlement cases for the research dashboard.
     * Get Recent Cases
     */
    async getRecentCasesApiV1AnalyticsRecentCasesGet(requestParameters: GetRecentCasesApiV1AnalyticsRecentCasesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RecentCase>> {
        const response = await this.getRecentCasesApiV1AnalyticsRecentCasesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get recent settlement cases for the research dashboard.
     * Get Recent Cases
     */
    async getRecentCasesApiV1AnalyticsRecentCasesGet_2Raw(requestParameters: GetRecentCasesApiV1AnalyticsRecentCasesGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RecentCase>>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/analytics/recent-cases`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RecentCaseFromJSON));
    }

    /**
     * Get recent settlement cases for the research dashboard.
     * Get Recent Cases
     */
    async getRecentCasesApiV1AnalyticsRecentCasesGet_2(requestParameters: GetRecentCasesApiV1AnalyticsRecentCasesGet0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RecentCase>> {
        const response = await this.getRecentCasesApiV1AnalyticsRecentCasesGet_2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get settlement analytics data for the research dashboard.
     * Get Settlement Data
     */
    async getSettlementDataApiV1AnalyticsSettlementDataGetRaw(requestParameters: GetSettlementDataApiV1AnalyticsSettlementDataGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SettlementData>> {
        const queryParameters: any = {};

        if (requestParameters['dateFrom'] != null) {
            queryParameters['date_from'] = (requestParameters['dateFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['date_to'] = (requestParameters['dateTo'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/analytics/settlement-data/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SettlementDataFromJSON(jsonValue));
    }

    /**
     * Get settlement analytics data for the research dashboard.
     * Get Settlement Data
     */
    async getSettlementDataApiV1AnalyticsSettlementDataGet(requestParameters: GetSettlementDataApiV1AnalyticsSettlementDataGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SettlementData> {
        const response = await this.getSettlementDataApiV1AnalyticsSettlementDataGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get settlement analytics data for the research dashboard.
     * Get Settlement Data
     */
    async getSettlementDataApiV1AnalyticsSettlementDataGet_3Raw(requestParameters: GetSettlementDataApiV1AnalyticsSettlementDataGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SettlementData>> {
        const queryParameters: any = {};

        if (requestParameters['dateFrom'] != null) {
            queryParameters['date_from'] = (requestParameters['dateFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['date_to'] = (requestParameters['dateTo'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/analytics/settlement-data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SettlementDataFromJSON(jsonValue));
    }

    /**
     * Get settlement analytics data for the research dashboard.
     * Get Settlement Data
     */
    async getSettlementDataApiV1AnalyticsSettlementDataGet_3(requestParameters: GetSettlementDataApiV1AnalyticsSettlementDataGet0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SettlementData> {
        const response = await this.getSettlementDataApiV1AnalyticsSettlementDataGet_3Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
